import React, { useState, useEffect } from 'react';
import { Gallery } from 'react-grid-gallery';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";

const Pictures = (props) => {
  const [pictures, setPictures] = useState([]);
  const [index, setIndex] = useState(-1);
  const [loading, setLoading] = useState(true);

  // If rendered via Route, props.isOpen is true. 
  // Determine if it should be open based on props or route.
  const isOpen = props.isOpen;

  const api = (process.env.REACT_APP_API_BASE_URL || '') + '/api/v1.0/pictures/?';
  const query = new URLSearchParams(props.location.search);
  const location = query.get('location');
  const country = query.get('country');
  const category = query.get('category');

  let param = '';
  let paramValue = '';
  let equal = '=';

  if (location && location.length > 0) {
    param = 'location';
    paramValue = location;
  } else if (country && country.length > 0) {
    param = 'country';
    paramValue = country;
  } else if (category && category.length > 0) {
    param = 'category';
    paramValue = category;
  } else {
    equal = '';
  }

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    setPictures([]); // Clear previous pictures
    
    fetch(api + param + equal + paramValue)
      .then(results => results.json())
      .then(data => {
        const mappedPictures = data.pictures.map(p => {
          return {
            src: p.thumbnail,
            original: p.orig, // High-res / original
            width: p.thumbnailWidth || 320,
            height: p.thumbnailHeight || 180,
            caption: p.caption,
            title: p.title
          };
        });
        setPictures(mappedPictures);
        setLoading(false);

        mappedPictures.forEach((p, idx) => {
          const img = new Image();
          img.onload = () => {
            const aspect = img.width / img.height;
            const newWidth = 180 * aspect;
            setPictures(prev => {
              if (prev.length === 0) return prev;
              const newArr = [...prev];
              if(newArr[idx]) {
                newArr[idx] = { ...newArr[idx], width: newWidth, height: 180 };
              }
              return newArr;
            });
          };
          img.src = p.src;
        });
      })
      .catch(() => setLoading(false));
  }, [api, param, equal, paramValue, isOpen]);

  const handleClick = (index) => setIndex(index);

  const handleCloseOverlay = () => {
    props.history.push('/');
  };



  const titleText = paramValue || "Gallery";

  return (
    <div className={`gallery-overlay ${isOpen ? 'open' : ''}`}>
      <div className="gallery-header">
        <h2 className="gallery-title">{titleText}</h2>
        <button className="close-btn" onClick={handleCloseOverlay} aria-label="Close">
          &times;
        </button>
      </div>
      
      <div className="gallery-content">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>Loading...</div>
        ) : pictures.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>No pictures found.</div>
        ) : (
          <Gallery
            images={pictures}
            onClick={handleClick}
            enableImageSelection={false}
            rowHeight={180}
            margin={4}
          />
        )}
      </div>

      <Lightbox
        slides={pictures.map(p => ({
          src: p.original, // Use high-res for lightbox
          description: (
             <div className="lightbox-caption-container" style={{ textAlign: 'center' }}>
               {p.caption && <p style={{ marginBottom: '8px' }}>{p.caption}</p>}
               {p.original && (
                 <a
                   href={p.original}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="original-link-btn"
                 >
                   View Original (High-Res)
                 </a>
               )}
             </div>
          )
        }))}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Captions]}
      />
    </div>
  );
}

export default Pictures;
